export const SET_UNSUBSCRIBE_REQUEST = 'UnsubscribePage/SET_UNSUBSCRIBE_REQUEST';
export const SET_UNSUBSCRIBE_SUCCESS = 'UnsubscribePage/SET_UNSUBSCRIBE_SUCCESS';
export const SET_UNSUBSCRIBE_FAILURE = 'UnsubscribePage/SET_UNSUBSCRIBE_FAILURE';
